export default {
  equipment: 'Equipo',
  service: 'Servicio',
  createdAt: 'Creado el',
  lastModifiedAt: 'Modificado el',
  actions: 'Acciones',
  place: 'Lugar',
  fromCreatedAt: 'Creado desde:',
  toCreatedAt: 'Creado hasta:',
  fromModifiedAt: 'Modificado desde:',
  toModifiedAt: 'Modificado hasta:',
  pageTitle: 'Borradores de Servicios',
  finishService: 'Finalizar Servicio',
  deleteDraftTitle: 'Eliminar Borrador de Servicio',
  deleteDraftMessage: '¿Está seguro de que desea eliminar el borrador de servicio?',
};
